<template>
  <div id="app">
    <bh-toast v-if="toast.show" v-bind="toast"/>
    <bh-confirmation-modal
      v-if="confirmationModal.show"
      :confirmButtonLabel="confirmationModal.confirmButtonLabel"
      :cancelButtonLabel="confirmationModal.cancelButtonLabel"
      :showModal.sync="confirmationModal.show"
      :title="confirmationModal.title"
      :subTitle="confirmationModal.subTitle"
      @output="confirmationModalOutput" />
    <bh-header v-if="isUserAuthenticated" />
    <div class="display-flex h100vw ma1-mb">
      <bh-sidenav v-if="isUserAuthenticated" class="pb1" />
      <bh-loader v-if="loading" loaderClasses="h100vh" />
      <router-view class="pr1-tb w100p" :class="{'pt10': $route && $route.name !=='LoginPage'}"/>
    </div>
  </div>
</template>

<script>
import '@/styles/main.css'

import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueSocketIO from 'vue-socket.io'
import config from '../config'

import { Sidenav, Header } from '@/components/common'

export default {
  name: 'app',
  computed: {
    ...mapGetters(['loading', 'confirmationModal', 'toast']),
    ...mapGetters('common/user', ['isUserAuthenticated'])
  },
  components: {
    'bh-sidenav': Sidenav,
    'bh-header': Header
  },
  methods: {
    ...mapActions(['clearConfirmationModal']),
    /**
     * When a user clicks on a button within the confirmation modal, trigger the given onClick method,
     * then clear the confirmation modal options { title, method, etc }
     * @param output
     * @returns {Promise<void>}
     */
    async confirmationModalOutput(output) {
      await this.confirmationModal.onClick(output)
      await this.clearConfirmationModal()
    },
    connect() {
      if (config.SOCKET_URL) {
        Vue.use(new VueSocketIO({
          connection: config.SOCKET_URL
          // options: {
          //   transports: ['websocket', 'polling']
          // }
        }))
      }
    }
  },
  watch: {
    isUserAuthenticated(value) {
      if (value && (!this.$socket || this.$socket?.disconnected)) this.connect()
    }
  }
}
</script>
